module.exports = __webpack_public_path__ + "icons/original/large/large-e2.bba1807b4ac83d4a610aa663676e1204.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-e2.png
// module id = dcOB
// module chunks = app